import Api from "./index";
import { endPoints, requestType } from "../constants/Variables";

export const fetchAllReviews = (id) => {
  return Api(endPoints.allReviews, id, requestType.POST);
};
